import classnames from 'classnames'
import Pagination from 'components/pagination'
import Entity from 'entities/pagination'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './list_pagination.module.scss'
import PaginationSummary from './pagination_summary'

const ListPagination = ({ className, pagination, onPageClick }) => (
  <div className={classnames(className, styles.list)}>
    <PaginationSummary pagination={pagination} format={I18n.t('components.list_pagination.format')} />
    <Pagination pagination={pagination} onPaginationClick={onPageClick} />
  </div>
)

ListPagination.propTypes = {
  className: PropTypes.string,
  pagination: PropTypes.instanceOf(Entity).isRequired,
  onPageClick: PropTypes.func.isRequired
}

ListPagination.defaultProps = {
  className: null
}

export default ListPagination
